import React from 'react';

import { Skeleton } from 'antd';
import { Text } from 'farmhub-ui-core';

import { EmptyDiv } from 'styled';

import {
  OrderInformationSectionHeader,
  OrderInformationSectionWrapper,
} from './styles';

type OrderInformationSectionProps = {
  title: string;
  children: React.ReactNode;
  isLoading: boolean;
  isPrint?: boolean;
};

const OrderInformationSection = ({
  title,
  children,
  isLoading,
  isPrint = false,
}: OrderInformationSectionProps) => (
  <OrderInformationSectionWrapper isPrint={isPrint}>
    <OrderInformationSectionHeader>
      {isLoading ? (
        <Skeleton.Input size="small" style={{ width: 250 }} />
      ) : (
        <Text color={isPrint ? 'black' : 'primary'} weight="bold">
          {title}
        </Text>
      )}
    </OrderInformationSectionHeader>
    <EmptyDiv>{children}</EmptyDiv>
  </OrderInformationSectionWrapper>
);

export default OrderInformationSection;
